import { useState } from "react";
import { Button, Input, Label } from "reactstrap";
import { RiEyeLine } from "react-icons/ri";
import { RiEyeCloseLine } from "react-icons/ri";

const PasswordInput = ({ value, setValue, label, placeholder }) => {
  const [passwordShown, setPasswordShown] = useState(false);

  return (
    <div className="mb-4">
      <Label className="figma-input-label-3 mb-3">{label}</Label>
      <div className="password-input">
        <Input
          placeholder={placeholder}
          type={passwordShown ? "text" : "password"}
          value={value}
          onChange={(e) => setValue(e?.target?.value)}
        />
        <Button
          onClick={() => setPasswordShown((prev) => !prev)}
          className="p-0 border-none"
        >
          {!passwordShown ? (
            <RiEyeCloseLine size={20} />
          ) : (
            <RiEyeLine size={20} />
          )}
        </Button>
      </div>
    </div>
  );
};

export default PasswordInput;
